import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '@material-ui/core';

export default function OnboardingButton(props) {
  const { color } = props;
  return <Button
    className="onboarding-card__button"
    {...props}
    color={undefined}
    style={{ background: color }}/>;
}

OnboardingButton.propTypes = {
  color: PropTypes.string
};

OnboardingButton.defaultProps = {
  color: undefined
};
